import React from "react";
import "./features.css";
import { FaBullhorn, FaChartLine, FaRobot, FaUsers, FaGlobe, FaLightbulb } from "react-icons/fa";

const Features = () => {
  const features = [
    {
      icon: <FaRobot />,
      title: "AI-Powered Strategy",
      desc: "Leverage Artificial Intelligence to analyze data, predict trends, and deliver smarter campaigns for your business growth.",
    },
    {
      icon: <FaChartLine />,
      title: "Performance Marketing",
      desc: "We design campaigns focused on measurable ROI and real business results, not just impressions or clicks.",
    },
    {
      icon: <FaBullhorn />,
      title: "Digital Advertising",
      desc: "Target your audience with advanced digital ad strategies across Meta, Google, and other top platforms.",
    },
    {
      icon: <FaUsers />,
      title: "Customer Engagement",
      desc: "Build long-term relationships with personalized communication that enhances loyalty and conversions.",
    },
    {
      icon: <FaGlobe />,
      title: "Global Reach",
      desc: "Expand your brand beyond boundaries with our global ad network and localized campaign execution.",
    },
    {
      icon: <FaLightbulb />,
      title: "Creative Innovation",
      desc: "Stand out with innovative creatives designed to capture attention and drive engagement.",
    },
  ];

  return (
    <section className="features-section" id="features">
      <div className="container">
        <h2 className="section-title">Our Powerful Features</h2>
        <p className="section-subtitle">
          Explore how our smart marketing and AI-driven tools can boost your business.
        </p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
